import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

const rootElement = document.getElementById("root");

ReactDOM.render(<App />, rootElement);

unregisterServiceWorker();
